import dynamic from 'next/dynamic';
import Head from 'next/head'

const Layout = dynamic(() => import('../components/layout'));

export default function CancellationPolicy() {
  return (
    <Layout>
      <Head>
        <title>
          Refer A Friend | Soluna London | Elite Aesthetics, Skin, Laser & Beauty
        </title>
        <meta
          name="description"
          content="Refer a friend or family member to experience our services & products at Soluna London. Call 0333 016 3500."
        />
        <link rel="canonical" href={`https://solunalondon.com/referrals/`} />
        <link
          rel="alternate"
          hrefLang="en-GB"
          href={`https://solunalondon.com/referrals/`}
        />
        <link
          rel="alternate"
          hrefLang="en"
          href={`https://solunalondon.com/referrals/`}
        />
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`https://solunalondon.com/referrals/`}
        />
      </Head>
      <section className="my-16 md:my-16 max-w-4xl px-4 sm:mt-24 sm:px-6 lg:ml-24 text-gray-700 text-lg lg:max-w-7xl lg:mx-auto lg:px-8 lg:pr-64">
        <h1 className="font-serif mb-12">
          <span className="mt-1 block text-4xl font-medium sm:text-5xl xl:text-6xl capitalize">
            <span className="block text-gray-900">
              Refer A{' '}
              <span className="text-brand-600">Friend Or Family Member</span>
            </span>
          </span>
        </h1>

        <article className='text-gray-600'>
          <div className="space-y-4">
            <p>
              At Soluna London we love our clients and work hard for our
              clients to love us, our product and services. We pride ourselves on
              delivering exceptional experiences and results that our clients
              return for time and time again.
            </p>
            <p>
              Share your exceptional experiences and results with family members
              and friends and be rewarded for sharing the love.
            </p>
          </div>

          <h2 className="my-8 font-serif text-gray-900 text-2xl">
            Want to know how it works? It’s simple.
          </h2>

          <div className="container mx-auto mb-8 2xl:px-32 space-y-4">
            <p>
              All you have to do is register for a Soluna London account.
              This will then give you a unique link you can share for friends
              and family to enjoy £50 off their first treatment. Not only that,
              as a loyal customer we give you £50 to spend.
            </p>
            <p>
              Got loads of friends? You can refer as many friends as you like,
              and each time you will receive £50 towards treatments or products.
            </p>
            {/* {user && (
              <>
                <p>
                  View your account credits and unique share link in your
                  account
                </p>
                <Link
                  className="block mt-8 btn-primary md:max-w-xs md:mx-auto"
                  to="/account/"
                >
                  Go to account
                </Link>
              </>
            )}
            {!user && (
              <>
                <p>Refer a friend today by creating an account</p>
                <Link
                  className="block mt-8 btn-primary md:max-w-xs md:mx-auto"
                  to="/sign-up/"
                >
                  Register Today
                </Link>
              </>
            )} */}
          </div>
          <h4 className="my-8 font-serif  text-gray-900 text-2xl">
            Terms & Conditions
          </h4>
          <div className="container mx-auto 2xl:px-32 space-y-4">
            <p>
              The new client is the one who has been referred to Soluna
              London by an existing Soluna London client.
            </p>
            <p>
              The referrer is the existing client who has referred a new client
              to Soluna London.
            </p>
            <p>
              Treatments are subject to a consultation and client suitability
              for treatment.
            </p>
            <p>Offer not applicable for any consultation fees.</p>
            <p>
              This promotion is open exclusively to UK residents aged 18 and
              over.
            </p>
            <p>
              This promotion can not be used in conjunction with any other offer
              or promotion.
            </p>
            <p>
              This offer is non-transferable and cannot be substituted by the
              client for any other products or treatments. £50 must also be used
              in one transaction.
            </p>
            <p>
              The referrer qualifies for the £50 offer once the referee they
              introduced has attended their first treatment appointment.
            </p>
            <p>
              £50 discount is applicable to treatments or products with a
              minimum spend £200
            </p>
            <p>
              £50 for referrer must be redeemed within 6 months from the date
              the new client started their treatment.
            </p>
            <p>
              The referrer can refer more than one friend however each £50
              discount can only be used against one transaction.
            </p>
            <p>
              The new client can use the £50 upon purchase of their first
              treatment or Soluna London products minimum spend £200.
            </p>
            <p>
              The new client must acknowledge the referrer and give their name
              at time of booking or attending consultation.
            </p>
            <p>
              The new client must also be identified through use of digital link
              at time of purchase for discount to be applied. These actions must
              be taken for discount to apply, if treatment started and above
              actions not followed, we will be unable to honor the new client or
              referrer.
            </p>
          </div>
        </article>
      </section>
    </Layout>
  )
}
